import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Swal from "sweetalert2";
import { useForm, SubmitHandler } from "react-hook-form";
import { Modal, InputControlled, Button, Icon } from "components";
import { editPatient } from "services/patients";
import { showError } from "utils/alerts";
import { format } from "date-fns";

interface IFormInputs {
  deathDate: string;
  deathCause: string;
}

const DeathModal = ({
  visible,
  toggle,
  patient,
  setPatient,
}: {
  visible: boolean;
  toggle: Function;
  patient: PatientType;
  setPatient: Function;
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const schema = yup.object({
    deathDate: yup.date().required(t("error.mustChooseADate")),
    deathCause: yup.string(),
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty },
  } = useForm<IFormInputs>({
    resolver: yupResolver(schema),
  });

  const handleOnSubmit: SubmitHandler<IFormInputs> = async (data) => {
    try {
      setLoading(true);
      if (patient.id) {
		console.log("INFOI", data);
        await editPatient(patient.id.toString(), {
          ...data,
          deathDate: format(new Date(data.deathDate), "yyyy-MM-dd"),
        });
        await setPatient({
          ...patient,
          deathDate:  format(new Date(data.deathDate), "yyyy-MM-dd"),
          deathCause: data.deathCause,
        });
        Swal.fire({
          title: "Paciente actualizado correctamente",
          icon: "success",
        });
      }
      reset();
      toggle();
    } catch (error) {
      showError("Error intentando actualizar el paciente.");
    } finally {
      setLoading(false);
    }
  };

  //TODO submit (save data), get existing data

  return (
    <Modal visible={visible} toggle={toggle}>
      <div className="p-8" style={{ width: "512px" }}>
        <div className="flex flex-row justify-between items-center mb-6">
          <div className="text-2xl text-orange">{t("death")}</div>
          <Icon
            name="Close"
            rounded
            className="border-orange border p-2"
            onClick={toggle}
          />
        </div>
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <div>
            <InputControlled
              name="deathDate"
              type="date"
              control={control}
              className="mb-5 w-full"
              defaultValue={
                patient.deathDate
                  ? new Date(patient?.deathDate)
                  : ""
              }
              labelClass="sm"
              label={t("deathDate")}
            />
            <InputControlled
              name="deathCause"
              type="textarea"
              className="w-full mt-[25px]"
              inputClasses="h-[200px]"
              control={control}
              defaultValue={patient.deathCause}
              labelClass="sm"
              label={t("deathCause")}
              placeholder={t("description")}
            />
          </div>

          <Button
            type="submit"
            disabled={!isDirty}
            loading={loading}
            className="c-orange font-extrabold text-sm mt-6 lg:col-span-4"
          >
            + {t("save")}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default DeathModal;
